import React from "react";
import { investmentsStatusSelector } from "../../../selectors/status";
import { Skeleton } from "../../skeleton/skeleton";
import { useSelector } from "../../../store/store";
import { deferralsSelector } from "../../../reducers/deferrals/defferals";
import { ContributionHistory } from "../../../models/contributions";
import { AccountContributionDetail } from "../dashboard-account-overview/dashboard-account-overview-util";
import { AccountOverviewRows } from "../dashboard-account-overview/AccountOverviewRows";
import Balance from "../../numbers/balance";
import { Link } from "react-router-dom";
import { ContributionRoutes } from "../../../routes/routes";
import { getMostRecentDateStr } from "../../../util/date-util";
import {
  DeferralElection,
  PlanDeferralElectionSet,
} from "../../../models/deferrals";
import "./dashboard-deferrals-panel.scss";

export function DashboardDeferrals() {
  // Continuing to use the contribution history, as the deferral data
  // that enroll rest responds with doesn't have the concept of
  // contribution history, that comes from Liabilities
  const contributionHistory: ContributionHistory[] = useSelector(
    (state) => state.contributions.contributionHistory.data
  );
  const mostRecentContribution: ContributionHistory | undefined =
    filterMostRecentContributionsFromHistory();

  const planDeferralElectionSet = useSelector(deferralsSelector);

  let electionSetData: PlanDeferralElectionSet | undefined = undefined;
  if (planDeferralElectionSet.data) {
    electionSetData = planDeferralElectionSet.data;
  }

  let deferrals: DeferralElection[] | undefined = undefined;
  if (electionSetData) {
    deferrals = electionSetData.employees[0].deferrals;
  }

  return (
    <div className="row">
      <div className="col-sm-12">
        {electionSetData && deferrals && (
          <div>
            {deferrals.map(
              (
                deferral: DeferralElection,
                index: string | number | null | undefined
              ) => {
                return (
                  <div key={index} data-testid={`deferral-${index}`}>
                    <span className="text-bold">{deferral.displayAmount}</span>
                    &nbsp;per payment of {deferral.displayCompTypeName}
                  </div>
                );
              }
            )}
            <div className="effective-date">
              <div className="show">
                Effective {electionSetData.effectiveDate}
              </div>
            </div>
          </div>
        )}
        <Skeleton selectors={[investmentsStatusSelector]} height={98}>
          {mostRecentContribution && (
            <AccountContributionDetail
              name={AccountOverviewRows.DEPOSIT}
              type={Balance}
              value={mostRecentContribution.transactionAmount}
              date={mostRecentContribution.transactionDate}
            />
          )}
        </Skeleton>
        <div className="view-contributions">
          <Link to={ContributionRoutes.Summary}>
            View Contributions{" "}
            <i className="fa fa-angle-right" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </div>
  );

  function filterMostRecentContributionsFromHistory():
    | ContributionHistory
    | undefined {
    if (contributionHistory.length > 0) {
      const stringTransactionDates = contributionHistory.map(
        (hist) => hist.transactionDate
      );
      const mostRecentTransactionDate = getMostRecentDateStr(
        stringTransactionDates
      );
      const mostRecentTransactionAmount = contributionHistory
        .filter((cont) => cont.transactionDate === mostRecentTransactionDate)
        .reduce((acc, cur) => {
          return acc + cur.transactionAmount;
        }, 0);
      return {
        transactionDate: mostRecentTransactionDate,
        transactionAmount: mostRecentTransactionAmount,
      } as ContributionHistory;
    }
  }
}
